/* eslint-disable no-undefined */
import React from 'react';
import {connect} from 'react-redux';
import strings from 'utils/strings';

import {updateObject} from 'utils/reducerUtils';

import AudioPlayer from 'components/AudioPlayer';

import * as noTutorial from './languages/no-tutorial.js';
import * as nnTutorial from './languages/nn-tutorial.js';

const tutorialObj = {
	no: noTutorial,
	nn: nnTutorial,
};
let count = 1;
const TOTAL_TUTORIAL_TRIALS = 3; 

class Tutorial extends React.Component {
	constructor(props) {
		super(props);

		this.tutorial = tutorialObj[strings.getLanguage()];
		this.tutorialAssignment = this.tutorial.tutorialAssignment;
		this.assignments = this.tutorial.assignments;
		this.exampleSound = this.tutorial.exampleSound;
		this.dinTurSound = this.tutorial.dinTurSound;
		this.starterTestenSound = this.tutorial.starterTestenSound;

		const results = {};

		for (const assignment of this.assignments) {
			results[assignment.id] = '';
		}
		this.state = {
			hasPlayedFirstAudio: false,
			results,
			counter: 1,
			choiceId: null,
			choiceValue: null,
			limit: 6,
			hideComment: false,
			showTestPanel: true,
			nextTutorial: false,
		};

		this.singleAssignment = {
			1: this.tutorial.assignment1,
			2: this.tutorial.assignment2,
			3: this.tutorial.assignment3,
			4: this.tutorial.assignment4,
			5: this.tutorial.assignment5,
			6: this.tutorial.assignment6,
			7: this.tutorial.assignment7,
			8: this.tutorial.assignment8,
		};

		this.audioRefs = {};
		this.preloadedImages = [];
	}
		componentDidMount() {
		this.preloadAllImages();
	}
	
	
	preloadAllImages = () => {
		if (typeof window === 'undefined') return;

		const urls = new Set();

		const collectFromAssignment = (assignment) => {
			if (!assignment) return;
			if (assignment.mainImg) urls.add(assignment.mainImg);
			if (Array.isArray(assignment.choices)) {
				for (const choice of assignment.choices) {
					if (choice && choice.img) urls.add(choice.img);
				}
			}
		};

		const groups = Object.values(this.singleAssignment);
		for (const group of groups) {
			if (Array.isArray(group)) {
				for (const assignment of group) {
					collectFromAssignment(assignment);
				}
			}
		}

		if (Array.isArray(this.assignments)) {
			for (const assignment of this.assignments) {
				collectFromAssignment(assignment);
			}
		}

		this.preloadedImages = Array.from(urls).map((src) => {
			const img = new Image();
			if ('decoding' in img) img.decoding = 'async';
			img.src = src;
			return img;
		});
	};


	setResults(id, value /* remark */) {
		const {results} = this.state;
		this.setState({
			results: updateObject(results, {
				[id]: value,
			}),
			hideComment: false,
			choiceId: id,
			choiceValue: value,
			/* nextTutorial:remark */
		});
		if (!this.props.isNorming) {
			this.scrollToTop();
		}
	}
	updateCount() {
		const {results} = this.state;
		this.setState(
			{
				results: updateObject(results, {
					[this.state.choiceId]: this.state.choiceValue,
				}),
			},
			() => {
				this.setState({
					counter: count,
					hideComment: true,
					showTestPanel: false,
					nextTutorial: true,
				});
				this.props.onShowAvatar(true);
			}
		);

		/* this.scrollToTop(); */
	}
	scrollToTop = () => {
		window.scrollTo({
			top: 169,
			behavior: 'smooth',
		});
	};

	render() {
		const {onNextStep} = this.props;
		this.scrollToTop();

		const {hasPlayedFirstAudio, results} = this.state;

		const allResultsHasValues = Object.keys(results).every(
			(key) => results[key]
		);

		const isNextButtonVisible = count === 4;

		return (
			<div className="lit-test">
				<div className="lit-tulleord lit-tulleord__tutorial">
					{this.singleAssignment[this.state.counter].map(
						(assignment) => {
							const {id, choices, text} = assignment;
							const textToShow = this.props.isNorming ? '':text;
							const currentAssignmentValue = results[id];
							let comment = null;
							for (const choice of choices) {
								if (id === 7) break;
								const commentToShow = this.props.isNorming ? '':choice.comment;
								if (
									currentAssignmentValue === choice.word &&
									!this.state.hideComment
								) {
								comment = (
									<p className="instruction">
										<span className={this.props.isNorming ? 'is-hidden-audio' : ''}>
											<AudioPlayer
												autoplay
												inline
												onErrorPlay={()=>{
													console.log('Something went wrong');
												}}
												onComplete={() => {
													if (choice.remark) {
														count = count + 1;
														this.updateCount();
													}
												}}
												ref={(ref) => {
													this.narDuStarterAudioPlayer = ref;
												}}
												refs={this.audioRefs}
												src={choice.sound}
											/>
										</span>
										{!this.props.isNorming && commentToShow}
									</p>
								);
								}
							}
							if (this.state.showTestPanel && count < 4) {
								return (
							                  <div
						                   className={`lit-words-wrapper ${this.props.isNorming ? 'is-norming' : ''}`}
						                   key={id}
						                 >
						                   {this.props.isNorming && this.renderNormingCounter()}	
										   <div className="lit-single-word">
											 <p
						                       className="instruction"
						                     >
												<AudioPlayer
													inline
													autoplay
													onErrorPlay={()=>{
														console.log('Something went wrong');
													}}
													ref={(ref) => {
														this.narDuStarterAudioPlayer = ref;
													}}
													refs={this.audioRefs}
													src={assignment.mainSound}
												/>
												{textToShow}
											</p>
										</div>
										<div className="lit-main-img-container">
											<img
												className={'imgMainItem'}
												src={assignment.mainImg}
											></img>
										</div>

										<div className="lit-words">
											{!this.props.isNorming && (
					                      <span className="lit-input__label lit-input__label--count">
					                        {id}
					                      </span>
					                    )}

											<div className="lit-word-list">
												{choices.map((choice, i) => {
													const idWord =
														i + choice.word;
													return (
														<span
															className="lit-word"
															key={idWord}
														>
															<input
																checked={
																	currentAssignmentValue ===
																	choice.word
																}
																className="lit-word__field"
																id={idWord}
																onChange={() =>
																	this.setResults(
																		id,
																		choice.word
																	)
																}
																type="radio"
															/>
															<label
																className="lit-word__label"
																htmlFor={idWord}
															>
																<div className="checkbox" />
																{/* {choice.word} */}
																<span>
																	<img
																		className={
																			'imgItem'
																		}
																		src={
																			choice.img
																		}
																	 />
																</span>
															</label>
														</span>
													);
												})}
											</div>
										</div>

										{comment}
									</div>
								);
							}
						}
					)}
				</div>
				{isNextButtonVisible && (
					<p className="instruction">
						<AudioPlayer
							inline
							autoplay
							onErrorPlay={()=>{
								console.log('Something went wrong');
							}}
							ref={(ref) => {
								this.narDuStarterAudioPlayer = ref;
							}}
							refs={this.audioRefs}
							src={this.starterTestenSound}
						/>
						{strings.tulleordStarterTesten}
					</p>
				)}
				{isNextButtonVisible && (
					<button
						className="lit-btn bg-primary"
						onClick={() => {
							onNextStep(results);
							this.props.onShowAvatar(false);
						}}
					>
						{strings.startTest}
					</button>
				)}
				{this.state.nextTutorial && count < 4 && (
					<button
						className="lit-btn bg-primary"
						onClick={() => {
							this.setState({
								showTestPanel: true,
								nextTutorial: false,
							});
							this.props.onShowAvatar(false);
						}}
					>
						{'Neste'}
					</button>
				)}
			</div>
		);
	}
}

Tutorial.prototype.renderNormingCounter = function renderNormingCounter() {
  const current = Math.min(
    Math.max(this.state.counter, 1),
    TOTAL_TUTORIAL_TRIALS
  );
  const pct = (current / TOTAL_TUTORIAL_TRIALS) * 100;

  const track = {
    height: 4,
    borderRadius: 999,
    background: 'rgba(255,255,255,0.28)',
    marginTop: 6,
    width: '100%',
    overflow: 'hidden'
  };
  const bar = {
    width: pct + '%',
    height: '100%',
    borderRadius: 999,
    background: '#ffffff',
    opacity: 0.95,
    transform: 'translateZ(0)'
  };

  return (
   <div
     className="lit-trial-pill"
     style={{ '--pct': `${pct}%` }}
     aria-label={`Prøve ${current} av ${TOTAL_TUTORIAL_TRIALS}`}
   >
     <div className="lit-trial-pill__label">
       {current} av {TOTAL_TUTORIAL_TRIALS}
     </div>
     <div className="lit-trial-pill__track">
       <div className="lit-trial-pill__bar" />
     </div>
   </div>
  );
};

const mapStateToProps = () => {
	return {};
};

export default connect(mapStateToProps)(Tutorial);
